import { useEffect } from 'react';
import useSideEffects from '../global/useSideEffects';

/**
 * The menu, while it holds the "visit ended" notice: the guest has seen why the cart is no longer at
 * the table, so /checkout and /payment need not send them back to it (useLeaveCheckoutWhenTableVisitEnds).
 * Apart from useTableVisitGuard, whose navigation the menu's note has no use for.
 */
export default function useTableVisitEndSeen(seen: boolean): void {
  const { markTableVisitEndSeen } = useSideEffects();

  useEffect(() => {
    if (seen) {
      markTableVisitEndSeen();
    }
  }, [seen, markTableVisitEndSeen]);
}
